import React, { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    reqGetDiscountAct,
    reqGetNewUserPricingPlanList,

} from '../../../api';
import { connect } from 'react-redux'
import { setActMealResData } from '../../../redux/actions/getAppPublicData';
import { store } from '../../../redux/store';
import utils from '../../../utils/utils';
import Language from '../../../i18n/Language';
import './index.scss';
import { setPageData } from '../../../redux/actions/getAppPageData';
import { Button } from '@shopify/polaris';
import { XIcon } from "@shopify/polaris-icons";

const t = Language;

class indexClass extends Component {
    state = {
        isHasActivityMeal: false, // 改版活动状态
        ActRversion: {}, // 改版活动数据
        act_expired_time: '00:00:00', // 倒计时
        act_expired_mills_time: '00', // 毫秒
        openActMealModal: false,
        isShowActivity: false, // 折扣活动
        planName: '', // 活动名称
        trial_days: -1, // 试用天数
        level: 1, // 用户等级
        isShowGiftBlock: true, // 是否展示礼物块
    };

    UNSAFE_componentWillMount() {
        window.giftEvent = this;
        const _store = this.props.public;
        // 获取改版活动数据
        if (Object.keys(_store.ActMealData).length > 0) {
            this.getDiscountActData(_store.ActMealData)
        } else {
            this.getDiscountActData();
        }

        let actStatus = 0;
        let isShowGiftBlock = true;
        try {
            actStatus = sessionStorage.getItem('actMealStatus') === null ? 1 : 0;
            isShowGiftBlock = !Boolean(sessionStorage.getItem('isShowGiftBlock'));
        } catch (e) { }
        this.setState({
            openActMealModal: Boolean(Number(actStatus)),
            isShowGiftBlock,
        }, () => {
            store.subscribe(() => {
                const _act = store.getState().public.ActMealData;
                if (_act?.plan_name) {
                    this.setState({
                        planName: _act.plan_name || '', // 活动名称
                    })
                }

                this.setState({
                    level: store.getState().public.level,
                })
            })
        })
    }

    // 获取活动改版弹窗数据
    getDiscountActData = async (data = null) => {
        if (Boolean(this.props.public.Language)) {
            let res = {};
            if (data) {
                res = data;
            } else {
                res = await reqGetDiscountAct();
                this.props.setActMealData(res);
            }
            if (res) {
                if (res.plan_type === 0) {
                    // 没有活动
                    this.setState({
                        ActRversion: {},
                        isHasActivityMeal: false,
                    })
                } else {
                    this.setState({
                        ActRversion: res,
                        isHasActivityMeal: true,
                        isShowActivity: true, // 是否存在活动
                        planName: res.plan_name || '',
                    })
                    if (Boolean(res.expired_time)) {
                        this.countdown(res.expired_time)
                    }
                }
                this.getPricingPlan(res?.activity_id || 0);
            } else {
                console.warn('Error activity data. Please contact the app development team ~');
            }
        } else {
            setTimeout(() => {
                this.getDiscountActData();
            }, 100)
        }
    }

    // 获取价格方案
    getPricingPlan = async (activity_id = 0) => {
        let cache = store.getState().page.pageInit?.pricingPlan;
        let params = {
            activity_id: activity_id,
        };
        let res = cache || (await reqGetNewUserPricingPlanList(params));
        if (res.ack === 1) {
            let pre_month = res.data.meal_list.month[1].coupon_info?.trial_days || 0;
            let pre_year = res.data.meal_list.year[1].coupon_info?.trial_days || 0;
            this.setState({
                trial_days: pre_month || pre_year || res.data.trial_days || 0, // 试用天数
                level: res.data.level,
            })
            this.props.getPageDataRedux(res); // 设置价格缓存数据
        }
    }

    // 时分秒倒计时
    countdown = async (end_time) => {
        let cacheTimer = setInterval(() => {
            let date1 = new Date(); //开始时间
            let date2 = end_time * 1000; //开始时间
            let date3 = date2 - date1 //时间差的毫秒数
            if (date3 < 1000) {
                clearInterval(cacheTimer);
                this.setState({
                    isHasActivityMeal: false,
                    openActMealModal: false
                })
            } else {
                //计算出小时数
                let leave1 = date3 % (24 * 3600 * 1000)  //计算天数后剩余的毫秒数
                let hours = Math.floor(date3 / (3600 * 1000))

                //计算相差分钟数
                let leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
                let minutes = Math.floor(leave2 / (60 * 1000))
                //计算相差秒数
                let leave3 = leave2 % (60 * 1000)   //计算分钟数后剩余的毫秒数
                let seconds = Math.round(leave3 / 1000)

                let exp_time = "";

                if (hours < 10) {
                    exp_time += "0" + hours + ":"
                } else {
                    exp_time += hours + ":"
                }
                if (minutes < 10) {
                    exp_time += "0" + minutes + ":"
                } else {
                    exp_time += minutes + ":"
                }
                if (seconds < 10) {
                    exp_time += "0" + seconds
                } else if (seconds === 60) {
                    exp_time += "00"
                } else {
                    exp_time += seconds
                }
                this.setState({ act_expired_time: exp_time })
            }
        }, 1000)
        // 毫秒倒计时
        setTimeout(() => {
            setInterval(() => {
                let date1 = new Date(); //开始时间
                let date2 = end_time * 1000; //开始时间
                let date3 = date2 - date1 //时间差的毫秒数
                if (date3 < 0) {
                    this.setState({ act_expired_mills_time: "00" })
                } else {
                    //计算相差毫秒数
                    let milli = date3 % (100)

                    let exp_time = "";

                    if (milli < 10) {
                        exp_time += "0" + milli
                    } else {
                        exp_time += milli
                    }
                    this.setState({ act_expired_mills_time: exp_time })
                }
            }, 80)
        }, 1000)
    }

    // 打开弹窗
    openActMealModalAction = (type) => {
        if (type === 1) {
            this.setState({
                openActMealModal: true
            }, () => {
                const frChild = window.FrameBlock;
                if (frChild) {
                    frChild.showTrialModal(2);
                }
            })
        } else {
            utils.routeJump(this, "/plan");
        }
    }

    // 关闭弹窗
    changeActMealModal = () => {
        this.setState({
            openActMealModal: false
        })
    }

    // 关闭礼物块
    handleCloseGiftBlock = () => {
        this.setState({
            isShowGiftBlock: false
        }, () => {
            try {
                sessionStorage.setItem('isShowGiftBlock', 'close');
            } catch (e) {}
        })
    }

    render() {
        const {
            state: {
                isHasActivityMeal,
                openActMealModal,
                act_expired_time,
                act_expired_mills_time,
                isShowActivity,
                planName,
                trial_days,
                level,
                isShowGiftBlock,
                
            },

        } = this;

        // 改版活动图标
        const backArr = ['/guide', '/plan'];
        const actMealIcon = !Boolean(backArr.includes(window.location.pathname)) && level === 1 && isShowGiftBlock ? (
            trial_days > 0 ? <div className='free_week_sticky' onClick={() => this.openActMealModalAction(1)}>
                <img src='/imgs/gift/freeWeekIcon.png' alt='' />
                <span>{t("START FREE TRIAL")}</span>
                <div>
                    <Button size='micro' icon={XIcon} variant='tertiary' onClick={(e) => {
                        e.stopPropagation();
                        this.handleCloseGiftBlock();
                    }} />
                </div>
            </div> : (isHasActivityMeal && !openActMealModal) ? (
                isShowActivity ? <div className="act_meal_BlackFryday" onClick={() => this.openActMealModalAction(2)}>
                    <img src='/imgs/gift/newGift.gif' alt='' />
                    <span>Get {(planName.indexOf('联盟') > -1 || planName.indexOf('新用户') > -1) ? 30 : 40}% OFF</span>
                </div> : <div className="act_meal_icon" onClick={() => this.openActMealModalAction(2)}>
                    <div className={`gift_icon_shake`}><span role="img" aria-label='emoji'>🎁 </span></div>
                    <div className="ami_main">
                        <span className="ami_time">{act_expired_time}</span>
                        <span className="ami_mills_time">{act_expired_mills_time}</span>
                    </div>
                </div>
            ) : null
        ) : null

        return actMealIcon;
    }

}

const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({
    // 设置改版活动数据
    setActMealData(data) {
        dispatch(setActMealResData(data))
    },

    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['pricingPlan', data]));
    },
})

indexClass = connect(
    mapStateToProps,
    mapDispatchToProps
)(indexClass);

export default withRouter(indexClass);
